import style from "../style/layout.module.css";
import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Colors,
} from "chart.js";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { Radar } from "react-chartjs-2";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Colors
);

export default function Ideal() {
  const LIMIT_POINT = 40;
  const ideal = [
    { name: "키", title: "height", value: 0 },
    { name: "직업", title: "job", value: 0 },
    { name: "학력", title: "degree", value: 0 },
    { name: "집안", title: "family", value: 0 },
    { name: "경제력", title: "economy", value: 0 },
  ];
  //  점수표
  const [radarData, setRadarData] = useState({
    height: 0,
    job: 0,
    degree: 0,
    family: 0,
    economy: 0,
  });

  const data = {
    labels: ideal.map((list) => list.name),
    datasets: [
      {
        label: "나의 이상형은?",
        data: Object.values(radarData)?.map((value) => value),
        backgroundColor: ({ chart: { ctx } }) => {
          const bg = ctx.createLinearGradient(0, 150, 0, 400);
          bg.addColorStop(0, "#e08a50a6");
          bg.addColorStop(1, "#e7bd8a62");
          return bg;
        },
        borderColor: "transparent",
        borderWidth: 0,
        color: "red",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        min: 0,
        max: 10,
        ticks: {
          stepSize: 1,
          color: "transparen",
          backdropColor: "transparent",
        },
      },
    },
  };
  const totalPoint = Object.values(radarData)
    .map((li) => li)
    .reduce((a, b) => {
      return a + b;
    });

  return (
    <div className={style.ideal}>
      <h4 className={style.ideal_title}>선호 이상형 등급기준</h4>
      <div
        style={{
          position: "relative",
          width: "99%",
          height: "auto",
          aspectRatio: "1/1",
        }}
      >
        <Radar data={data} options={options} />
      </div>
      {ideal.map((list, i) => (
        <TextInput
          key={list.title}
          title={list.title}
          name={list.name}
          setRadarData={setRadarData}
          radarData={radarData}
          limit={LIMIT_POINT}
          totalPoint={totalPoint}
        />
      ))}
      <p className={style.amount}>잔여 포인트 : {LIMIT_POINT - totalPoint}</p>
    </div>
  );
}

const TextInput = ({
  title,
  name,
  setRadarData,
  radarData,
  limit,
  totalPoint,
}) => {
  const [number, setNumber] = useState(0);

  const handleMinus = () => {
    if (number > 0) {
      setNumber((prev) => prev - 1);
    }
  };
  const handlePlus = () => {
    if (totalPoint >= limit) {
      alert("잔여 포인트가 없습니다.");
    }
    if (number < 10 && totalPoint < limit) {
      setNumber((prev) => prev + 1);
    }
  };

  const onChangeHandler = (title, number) => {
    setRadarData((prev) => {
      return {
        ...prev,
        [title]: number,
      };
    });
  };
  useEffect(() => {
    onChangeHandler(title, number);
  }, [number]);

  return (
    <label
      htmlFor={title}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        marginBottom: "10px",
        height: "19px",
      }}
    >
      <span style={{ width: 50 }}>{name}</span>

      <button type="button" onClick={handleMinus}>
        <AiOutlineMinus style={{ height: "100%" }} />
      </button>
      {/* <input
        type="range"
        name={title}
        id={title}
        max={10}
        placeholder="1~10"
        className="input_text"
        value={number}
        readOnly
      /> */}
      <progress value={number} max={10}></progress>
      <button
        type="button"
        onClick={handlePlus}
        name={title}
        id={title}
        className="input_text"
      >
        <AiOutlinePlus style={{ height: "100%" }} />
      </button>
    </label>
  );
};
